var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "classification" }, [
    _vm._v(" 商户资质审核 "),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }